import { ChangeDetectionStrategy, Component, computed, input, Signal, signal } from '@angular/core';

import { ChdButton, ChdDialog, ChdText } from '@cp-produkte/cruise-hospitality-design';
import { Subject } from 'rxjs';

import { SpaButtonComponent } from '@components/spa-button/spa-button.component';

import { ModalComponent } from '../../notification.service';

export interface ModalButton {
  dataTestID?: string;
  disabled?: Signal<boolean>;
  icon?: string;
  iconPlacement?: (typeof SpaButtonComponent)['prototype']['iconPlacement'];
  label?: string;
  shape?: (typeof SpaButtonComponent)['prototype']['shape'];
  action?: () => void | Promise<void>;
}

@Component({
  selector: 'spa-notification-modal',
  imports: [ChdButton, ChdDialog, ChdText],
  templateUrl: './notification-modal.component.html',
  styleUrl: './notification-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationModalComponent implements ModalComponent {
  titleString = input<string | undefined>(undefined);
  messages = input<string | string[] | undefined>(undefined);
  buttons = input<ModalButton[] | undefined>(undefined);

  normalizedMessage = computed(() => {
    if (typeof this.messages() === 'string') {
      return [this.messages()];
    }
    if (Array.isArray(this.messages())) {
      return this.messages();
    }
    return [];
  });

  visible = signal(true);

  close = new Subject<void>();

  onCloseModal() {
    this.close.next();
    this.close.complete();
  }

  closeModal() {
    this.visible.set(false);
  }
}
